// extracted by mini-css-extract-plugin
export default {"input":"SwitchToggle_input__IV24c","toggle":"SwitchToggle_toggle__21Fqx"};